import { Box, Button, Typography } from '@mui/material'
import { useLoaderData, useNavigate } from 'react-router-dom'
import PageAppBar from 'components/PageAppBar'
import { ResourceModel } from 'types'
import ResourceDataGrid from 'components/ResourceDataGrid'
import * as React from 'react'

export default function ResourcesPage() {
  const resources = useLoaderData() as ResourceModel[]
  const navigate = useNavigate()

  return (
    <PageAppBar pageName="Ressources">
      <Box
        sx={{
          p: 2,
          height: 'calc(100vh - 64px)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography variant="h4" gutterBottom>
          Gestion des Ressources
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1,
          }}
        >
          <Button variant="contained" onClick={() => navigate('/resource')}>
            Créer une ressource
          </Button>
        </Box>

        <Box sx={{ flexGrow: 1, width: '100%' }}>
          <ResourceDataGrid resources={resources} />
        </Box>
      </Box>
    </PageAppBar>
  )
}
